/*
 * MDB shim for ModalBody
 * Files currently importing this symbol from "mdbreact":
 * - src/App.jsx
 * - src/Components/Custom/CreateModal.jsx - done
 * - src/Seating/Accounts/accountDetail.jsx - done
 * - src/Seating/Activities/activities-edit.jsx - done
 * - src/Seating/Activities/activitiesModal.jsx - done
 * - src/Seating/Contacts/contact-edit.jsx - done
 * - src/Seating/Deliveries/deliveryList.jsx - 
 * - src/Seating/Faxes/faxes.jsx - done
 * - src/Seating/InventoryProduct/inventoryProductTable.jsx - done
 * - src/Seating/Orders/RecurringOrders.jsx - done
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx - done
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx - done
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx - done
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx - done
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx - done
 * - src/Seating/Settings/creditCardTypes.jsx - done
 * - src/Seating/Settings/deliveryAcknowledgements.jsx - done
 * - src/Seating/Settings/editProductSubTypes.jsx - done
 * - src/Seating/Settings/expenseTypes.jsx - done
 * - src/Seating/Settings/manualDocumentBuilder.jsx - done
 * - src/Seating/Settings/productTypes.jsx - done
 * - src/Seating/Settings/reasons.jsx - done
 * - src/Seating/Settings/trainingLink.jsx - done
 * - src/Seating/Settings/vendor.jsx - done
 */

import MUIDialogContent from "@mui/material/DialogContent";

export default function ModalBody({ children, ...rest }) {
    return <MUIDialogContent {...rest}>{children}</MUIDialogContent>;
}
